import React from 'react';
import { connect } from 'react-redux';
import './LocalInformationPageMl.css';
import { DynamicBackground } from '../../../../components'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import { TimelineLite } from "gsap/all";
import { isWebpSupported } from 'react-image-webp/dist/utils';
import { faCalendar, faMapMarkerAlt, faPhone, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Carousel from 'react-bootstrap/Carousel';

class LocalInformationPageMl extends React.Component {

  constructor(props) {
    super(props);
    this.logoTl = new TimelineLite({ paused: true });
    this.subhead = null;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.logoTl
      .set(this.content, { autoAlpha: 1 })// show content div
      .from(this.head, 0.5, { left: 100, autoAlpha: 0 })
      .from(this.subhead, 0.5, { left: -100, autoAlpha: 0 }, "-=0.25") // added -0.25 seconds prior to end this.of timeline
    this.logoTl.play()
  }

  handleDeleteUser(id) {
    //return (e) => this.props.dispatch(userActions.delete(id));

  }

  render() {

    return (

      <DynamicBackground customOverlay="rgba(0, 0, 0, 0.5)" background={isWebpSupported() ? "https://gecorcloud.com/images/onil.webp" : "https://gecorcloud.com/images/onil.jpg"}>
        <div className="infoBoxMelilla" ref={div => this.subhead = div}>
          <div className="infoTit">
            <h1><b tabIndex="1">INFORMACIÓN LOCAL</b></h1>
          </div>
          {/*   Box 1   */}
          <Card >
            <Card.Body>
              <Card.Text as="div">
                <Row>
                  <Col sm={12}>
                    <div className='local-enviromental-title'>
                      <p>Ordenanzas Medio Ambiente</p>
                      <div class="text-decor"></div>
                    </div>
                  </Col>
                  <Col md={6} >
                    <Row>
                      <Col sm={12}>
                        <p tabIndex="4" className="par-hov" onClick={() => window.open('https://gecorsystem.blob.core.windows.net/public/info/otros/Documentos/Melilla/plan_inspecciones_medioambientales_melilla.pdf')}>
                          Establece el marco de las inspecciones ambientales en la ciudad para controlar el cumplimiento normativo.
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <p tabIndex="12" className="par-hov" onClick={() => window.open('https://gecorsystem.blob.core.windows.net/public/info/otros/Documentos/Melilla/ordenanza_recogida_residuos_municipales.pdf')}>
                          Regula el sistema de recogida y gestión de los residuos urbanos.
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <p tabIndex="13" className="par-hov" onClick={() => window.open('https://gecorsystem.blob.core.windows.net/public/info/otros/Documentos/Melilla/ordenanza_contaminacion_ruidos_vibraciones.pdf')}>
                          Define los límites permitidos y las medidas contra la contaminación acústica y por vibraciones.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={{ span: 6, offset: 0 }}>
                    <Row>
                      <Col sm={12}>
                        <p tabIndex="3" className="par-hov" onClick={() => window.open('https://gecorsystem.blob.core.windows.net/public/info/otros/Documentos/Melilla/decreto_materia_proteccion_animal.pdf')}>
                          Garantiza el bienestar animal y regula su tenencia responsable.
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <p tabIndex="16" className="par-hov" onClick={() => window.open('https://gecorsystem.blob.core.windows.net/public/info/otros/Documentos/Melilla/Zona_de_bajas_emisiones.pdf')}>
                          Regula la creación y funcionamiento de zonas de bajas emisiones para mejorar la calidad del aire.
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <p tabIndex="17" className="par-hov" onClick={() => window.open('https://gecorsystem.blob.core.windows.net/public/info/otros/Documentos/Melilla/bando_cerramiento_solares_terrenos_urbanos_sin_edificar.pdf')}>
                          Obliga al cerramiento y mantenimiento de terrenos sin construir para evitar riesgos y mejorar la imagen urbana.
                        </p>
                      </Col>
                    </Row>                    
                  </Col>

                </Row>
              </Card.Text>
            </Card.Body>
          </Card>

          {/*   Box 2   */}

          <Card ref={card => this.content = card}>
            <Card.Body>
              <Card.Text as="div">
                <Row>

                  <Col sm={8}>
                        <div className='local-enviromental-title'>
                          <p>Gestión de residuos</p>
                          <div class="text-decor"></div>
                        </div>
                        <Row>
                          <Col sm={6}>
                            <Row>
                            <p>La gestión de residuos en Melilla está a cargo de REMESA, la empresa encargada de la recogida, tratamiento y valorización de los desechos en la ciudad. 
                              Existen contenedores distribuidos por toda la ciudad para la separación de residuos como papel, vidrio, envases y materia orgánica. 
                            </p>

                        <p tabIndex="23">El objetivo principal de la gestión de residuos en Melilla es reducir la cantidad de residuos generados y fomentar el reciclaje, 
                          alineándose con las normativas europeas de gestión sostenible. Además, REMESA trabaja en colaboración con la Ciudad Autónoma para sensibilizar a la población 
                          y promover hábitos responsables, mejorando así el impacto ambiental y contribuyendo a la protección del entorno urbano.</p>
                              
                            </Row>
                          </Col>
                          <Col sm={6}>
                          <img className="mt-2" src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/contenedor_azul.jpg" width="100%" alt="imagen-info3" />
                          </Col>
                        </Row>
                      </Col>

                  <Col sm={4}>
                    <h4 tabIndex="30"> Recogida de Muebles y Enseres</h4>
                    <div class="text-decor"></div>
                    <Row>
                      <Col sm={6}>
                        <Row>
                          <p tabIndex="31">El servicio de recogida de enseres voluminosos en Melilla está diseñado para facilitar a los ciudadanos la correcta gestión de muebles y objetos de gran tamaño que ya no necesitan. La recogida se realiza a domicilio, permitiendo el retiro de hasta un máximo de tres enseres por cada cita solicitada.
                          </p>
                          
                        </Row>
                      </Col>
                      <Col sm={6}>
                        <p>
                        <img src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/recogida_enseres.jpg" width="100%" height="170px" alt="Ecoparque fijo" />
                        </p>
                        <p tabIndex="29"><FontAwesomeIcon icon={faCalendar} />De Lunes a Viernes, mañanas de 9:00 a 14:00 y tardes de 16:00 a 20:00. 
                        Sabados de 9:00 a 14:00. </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>


                
                <Row>
                  <Col sm={6}>
                    <h4 tabIndex="25"> Punto limpio fijo</h4>
                    <div class="text-decor"></div>
                    <Row>
                      <Col sm={6}>
                        <Row>
                        <p tabIndex="26">El punto limpio de la Calle Río Jarama, s/n (CP: 52002), gestionado por REMESA, permite depositar residuos domésticos, voluminosos, eléctricos 
                          y reciclables.</p>
                        <p tabIndex="27">Cuenta con personal cualificado que asegura una gestión responsable, contribuyendo a la protección del medio ambiente en Melilla.</p>
                        </Row>
                      </Col>
                      <Col sm={6}>
                        <img src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/punto_limpio_fijo.png" width="100%" height="170px" alt="Ecoparque fijo" />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <iframe title="Punto Limpio Melilla" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1628.0972311065084!2d-2.9417774995119106!3d35.30114927090304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd770585e8a18d6f%3A0xe5ac8476111c6c39!2sRemesa!5e0!3m2!1ses!2ses!4v1746696027107!5m2!1ses!2ses" width="100%" height="170px" styles="border:0;" />
                      </Col>
                      <Col sm={6}>
                        <p tabIndex="28"><FontAwesomeIcon icon={faMapMarkerAlt} /> Calle Río Jarama, S/N, 52002 Melilla, Ciudad Autónoma de Melilla, España</p>
                        <p tabIndex="29"><FontAwesomeIcon icon={faCalendar} />De Lunes a Viernes, mañanas de 9:00 a 14:00 y tardes de 16:00 a 20:00. 
                        Sabados de 9:00 a 14:00. </p>
                        <p><FontAwesomeIcon icon={faPhone} /> 952686000 </p>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={6}>
                    <h4 tabIndex="25"> Punto limpio movil</h4>
                    <div class="text-decor"></div>
                    <Row>
                      <Col sm={6}>
                        <Row>
                          <p tabIndex="26">El Punto Limpio Móvil de Melilla es un servicio itinerante que facilita la recogida de residuos domésticos especiales, acercando la gestión ambiental
                             responsable a los distintos barrios de la ciudad.</p>
                          <p tabIndex="27">Se recogen materiales como pequeños electrodomésticos, pilas o aceite usado, contribuyendo a reducir la contaminación y fomentar hábitos sostenibles entre la ciudadanía.</p>
                        </Row>
                      </Col>
                      <Col sm={6}>
                        <img src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/Punto_limpio_movil_imagen.jpg" width="100%" height="170px" alt="Ecoparque fijo" />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr className="line" ></hr>
                <Row>
                  <Col sm={12}>
                    <p tabIndex="33" className="par-hov" onClick={() => window.open('https://www.melilla.es/melillaportal/contenedor.jsp?seccion=s_fdes_d4_v1.jsp&contenido=23963&nivel=1400&tipo=6&codMenu=705&codMenuPN=601&codMenuSN=8', '_blank')}>
                      Plan Local de Gestión de Residuos Asimilables
                    </p>
                  </Col>
                </Row>
              </Card.Text>
            </Card.Body>
          </Card>


          {/*   Box 3   */}

          <Card>
            <Card.Body>
              <Card.Text as="div">
                <Row>
                  <Col sm={12}>
                    <div className='local-enviromental-title'>
                      <p tabIndex="35">Trámites</p>
                      <div class="text-decor"></div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col sm={12}>
                        <div className="plocal">
                          <div className="textColorInfo">
                            <p tabIndex="36" className="par">
                              <b>Instrucciones para la recogida de voluminosos:</b>
                            </p>
                            <p> El peticionario deberá llamar al teléfono 952 68 47 65, extensión 5 y deberán indicar su nombre, dirección, número de teléfono y el tipo de objeto a retirar.
                            </p>
                            <p> No se permite depositar residuos voluminosos en la vía pública sin autorización, solo el día de la cita de 9:30 a 12:30.
                            </p>
                            <img src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/recogida_voluminosos.jpg" width="100%" alt="Recogida de enseres" />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={{ span: 6, offset: 0 }}>
                    <Row>
                      <Col sm={12}>
                        <div className="plocal">
                          <div className="textColorInfo">
                            <p tabIndex="37" className="par">
                              <b>¿Sabías que el aceite también es reciclable?</b>
                            </p>
                            <p>Melilla dispone de varios puntos de recogida de aceite doméstico usado. Con tu colaboración, evitamos contaminar las aguas y el medio ambiente que nos rodea. 
                            </p>
                            <p>Los ciudadanos pueden depositar el aceite alimentario en los contenedores naranjas.</p>
                            <img src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/contenedor_aceite2.jpg" width="100%" alt="Ecoparque fijo" />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <p tabIndex="33" className="par-hov" onClick={() => window.open('https://gecorsystem.blob.core.windows.net/public/info/otros/Documentos/Melilla/Recogida_aceite.pdf', '_blank')}>
                      Puntos de recogida del aceite
                    </p>
                  </Col>
                </Row>
              </Card.Text>
            </Card.Body>
          </Card>


          {/*   Box 4   */}

          <Card>
            <Card.Body>
              <Card.Text as="div">

                <Row>
                  <Col sm={12}>
                    <div className='local-enviromental-title'>
                      <p>PARQUES Y PLAZAS</p>
                      <div class="text-decor"></div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <Carousel>
                      <Carousel.Item key={1}>
                        <Row>
                          <Col md={6}>
                            <Row>
                              <img
                                className="d-block w-100  mt-5"
                                src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/parque_hernandez.jpg"
                                alt="deslizar"
                              />
                            </Row>
                          </Col>
                          <Col md={6}>
                            <Row>
                              <p tabIndex="38" className="par">
                                <b>Parque Hernández</b>
                              </p>
                              <p>El Parque Hernández, ubicado en el centro de Melilla junto a la Plaza de España, es el parque más emblemático y antiguo de la ciudad, 
                                inaugurado en 1902. Destaca por sus amplias zonas ajardinadas con palmeras milenarias, vegetación exótica y estatuas de figuras ilustres como
                                 Lope de Vega y Félix Rodríguez de la Fuente. 
                              </p>
                              <p>Es un lugar de esparcimiento y encuentro ciudadano, declarado Parque Histórico en 2007.
                              </p>
                            </Row>
                          </Col>
                        </Row>
                      </Carousel.Item>
                      <Carousel.Item key={2}>
                        <Row>
                          <Col md={6}>
                            <Row>
                              <img
                                className="d-block w-100  mt-5"
                                src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/parque_juan_carlos.jpg"
                                alt="deslizar"
                              />
                            </Row>
                          </Col>
                          <Col md={6}>
                            <Row>
                              <p tabIndex="39" className="par">
                                <b>Parque forestal Juan Carlos I</b>
                              </p>
                              <p>El Parque Forestal Juan Carlos I Rey, situado en la periferia de Melilla, es considerado el pulmón verde de la ciudad desde su inauguración en 2007. 
                                Con seis hectáreas de extensión, alberga flora mediterránea y fauna autóctona, ofreciendo espacios para pasear, practicar deporte y disfrutar en familia. 
                              </p><p>Su historia está ligada al desarrollo agrícola de Melilla, ya que se ubica en los terrenos de la antigua Granja Agrícola del Estado.</p>
                            </Row>
                          </Col>
                        </Row>
                      </Carousel.Item>
                      <Carousel.Item key={3}>
                        <Row>
                          <Col md={6}>
                            <Row>
                              <img
                                className="d-block w-100  mt-5"
                                src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/plaza_espana.jpg"
                                alt="deslizar"
                              />
                            </Row>
                          </Col>
                          <Col md={6}>
                            <Row>
                              <p tabIndex="40" className="par">
                                <b>Plaza de España</b>
                              </p>
                              <p>La Plaza de España es el centro neurálgico de Melilla y destaca por su arquitectura modernista. Rodeada de edificios emblemáticos, conecta el casco antiguo con el ensanche y alberga el Monumento a los Héroes de España.</p>
                              <p>La Plaza de las Culturas representa la convivencia entre las culturas cristiana, musulmana, judía e hindú. Es un espacio abierto frente a Melilla la Vieja, usado para encuentros y eventos culturales.</p>
                            </Row>
                          </Col>
                        </Row>
                      </Carousel.Item>
                      <Carousel.Item key={4}>
                        <Row>
                          <Col md={6}>
                            <Row>
                              <img
                                className="d-block w-100 mt-5"
                                src="https://gecorsystem.blob.core.windows.net/public/info/otros/Fotos/Web/Melilla/plaza_culturas.jpg"
                                alt="deslizar"
                              />
                            </Row>
                          </Col>
                          <Col md={6}>
                            <Row>
                              <p tabIndex="40" className="par">
                                <b>Plaza de las Culturas</b>
                              </p>
                              <p>La Plaza de España es el centro neurálgico de Melilla y destaca por su arquitectura modernista. Rodeada de edificios emblemáticos, 
                                conecta el casco antiguo con el ensanche y alberga el Monumento a los Héroes de España.</p>
                              <p>La Plaza de las Culturas representa la convivencia entre las culturas cristiana, musulmana, judía e hindú. Es un espacio abierto frente a Melilla la Vieja, 
                                usado para encuentros y eventos culturales.</p>
                            </Row>
                          </Col>
                        </Row>
                      </Carousel.Item>
                    </Carousel>
                  </Col>
                </Row>
              </Card.Text>
            </Card.Body>
          </Card>

        </div>
      </DynamicBackground >
    );
  }
}

const mapStateToProps = (state) => {
  const { users } = state;
  const { user } = users;
  return {
    user
  };
}

const connectedLocalInformationPageMl = connect(mapStateToProps)(LocalInformationPageMl);
export { connectedLocalInformationPageMl as LocalInformationPageMl }; 